import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'app.containers.AIJobsDirectoryCareerSite.title',
    defaultMessage: 'AI Jobs Directory Career Site',
  },
  header: {
    id: 'app.containers.AIJobsDirectoryCareerSite.header',
    defaultMessage: 'Jobs Directory Settings',
  },
  generalSettings: {
    id: 'app.containers.AIJobsDirectoryCareerSite.generalSettings',
    defaultMessage: 'General Settings',
  },
  brandYourWidget: {
    id: 'app.containers.AIJobsDirectoryCareerSite.brandYourWidget',
    defaultMessage: 'Brand your widget',
  },
  brandYourWidgetDesc: {
    id: 'app.containers.AIJobsDirectoryCareerSite.brandYourWidgetDesc',
    defaultMessage:
      'Select a brand to apply its logo and color, as well as all the chatbot widget settings configured on this page.',
  },
  additionaBrandInfo: {
    id: 'app.containers.AIJobsDirectoryCareerSite.additionaBrandInfo',
    defaultMessage:
      'To add additional brands or configure the existing ones, go to Company Settings.',
  },
  aiJobCategorization: {
    id: 'app.containers.AIJobsDirectoryCareerSite.aiJobCategorization',
    defaultMessage: 'AI Job Categorization',
  },
  categoryFilterLabel: {
    id: 'app.containers.AIJobsDirectoryCareerSite.categoryFilterLabel',
    defaultMessage: 'Category Filter Label (Default: Category)',
  },
  categoryFilterLabelDefault: {
    id: 'app.containers.AIJobsDirectoryCareerSite.categoryFilterLabelDefault',
    defaultMessage: 'Category',
  },
  categorizationSwitchLabel: {
    id: 'app.containers.AIJobsDirectoryCareerSite.categorizationSwitchLabel',
    defaultMessage: 'Categorize jobs by Job Type',
  },
  displayCompensationTypeSwitchLabel: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayCompensationTypeSwitchLabel',
    defaultMessage: 'Display Compensation Type',
  },
  displayCompensationTypeSwitchDesc: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayCompensationTypeSwitchDesc',
    defaultMessage:
      'Allow potential applicants to filter openings by Compensation Type(Per Hour, Per Day, Per Month, per Year)',
  },
  categorizationSwitchDesc: {
    id: 'app.containers.AIJobsDirectoryCareerSite.categorizationSwitchDesc',
    defaultMessage:
      'Allow AI to organize Fountain positions into eight different categories by Job Department and Type (ex. Sales, Marketing, etc)',
  },
  experienceLevelSwitchLabel: {
    id: 'app.containers.AIJobsDirectoryCareerSite.experienceLevelSwitchLabel',
    defaultMessage: 'Categorize jobs by Experience Level',
  },
  experienceLevelSwitchDesc: {
    id: 'app.containers.AIJobsDirectoryCareerSite.experienceLevelSwitchDesc',
    defaultMessage:
      'Allow AI to organize positions into three different work experience categories (ex.Entry-level, Mid-level and Senior-level)',
  },
  caiAgentSettings: {
    id: 'app.containers.AIJobsDirectoryCareerSite.caiAgentSettings',
    defaultMessage: 'Candidate AI Agent Settings',
  },
  faqChatPrompts: {
    id: 'app.containers.AIJobsDirectoryCareerSite.faqChatPrompts',
    defaultMessage: 'FAQ Chat Prompts',
  },
  faqChatPromptsDesc: {
    id: 'app.containers.AIJobsDirectoryCareerSite.faqChatPromptsDesc',
    defaultMessage:
      'Adds Frequently Asked Question (FAQ) chat prompts to the job directory site to help candidates quickly find answers. When applicants clicks on a question, the Candidate AI Agent chat widget will open and respond directly to that question for a seamless and engaging experience. Add up to 5 custom FAQ Chat Prompts.',
  },
  question: {
    id: 'app.containers.AIJobsDirectoryCareerSite.question',
    defaultMessage: 'Question',
  },
  settingUpdateSuccess: {
    id: 'app.containers.AIJobsDirectoryCareerSite.settingUpdateSuccess',
    defaultMessage: 'Setting updated successfully',
  },
  settingUpdateFailed: {
    id: 'app.containers.AIJobsDirectoryCareerSite.settingUpdateFailed',
    defaultMessage: 'Setting update failed',
  },
  previewCareerSite: {
    id: 'app.containers.AIJobsDirectoryCareerSite.previewCareerSite',
    defaultMessage: 'Preview Career Site',
  },
  enableChatAgent: {
    id: 'app.containers.AIJobsDirectoryCareerSite.enableChatAgent',
    defaultMessage: 'An active chat agent is required',
  },
  ssoSettings: {
    id: 'app.containers.AIJobsDirectoryCareerSite.ssoSettings',
    defaultMessage: 'Internal Career Site SSO',
  },
  ssoEnabled: {
    id: 'app.containers.AIJobsDirectoryCareerSite.ssoEnabled',
    defaultMessage: 'Enabled',
  },
  ssoSettingDescription: {
    id: 'app.containers.AIJobsDirectoryCareerSite.ssoSettingDescription',
    defaultMessage:
      'Internal career site enables your employees to login via SSO. Please provide the relevant details under the Identity provider section to enable the SSO feature.',
  },
  serviceProviderTitle: {
    id: 'app.containers.AIJobsDirectoryCareerSite.serviceProviderTitle',
    defaultMessage: 'Service Provider (SP) Settings',
  },
  acsUrl: {
    id: 'app.containers.AIJobsDirectoryCareerSite.acsUrl',
    defaultMessage: 'ACS URL',
  },
  spEntityId: {
    id: 'app.containers.AIJobsDirectoryCareerSite.spEntityId',
    defaultMessage: 'SP Entity ID',
  },
  spMetaData: {
    id: 'app.containers.AIJobsDirectoryCareerSite.spMetaData',
    defaultMessage: 'SP MetaData',
  },
  identityProviderTitle: {
    id: 'app.containers.AIJobsDirectoryCareerSite.identityProviderTitle',
    defaultMessage: 'Identity Provider (IdP) Settings',
  },
  loginUrl: {
    id: 'app.containers.AIJobsDirectoryCareerSite.loginUrl',
    defaultMessage: 'Login URL',
  },
  idpEntityId: {
    id: 'app.containers.AIJobsDirectoryCareerSite.idpEntityId',
    defaultMessage: 'IdP Entity ID',
  },
  idpCertificate: {
    id: 'app.containers.AIJobsDirectoryCareerSite.idpCertificate',
    defaultMessage: 'Idp Certificate',
  },
  jobsDirectoryFilters: {
    id: 'app.containers.AIJobsDirectoryCareerSite.jobsDirectoryFilters',
    defaultMessage: 'Job Directory Filters',
  },
  displayLocationFilterSwitchLabel: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayLocationFilterSwitchLabel',
    defaultMessage: 'Display Location Filter',
  },
  displayLocationFilterSwitchDesc: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayLocationFilterSwitchDesc',
    defaultMessage:
      'Allow potential applicants to filter openings by location on positions',
  },
  displayPositionFilterSwitchLabel: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayPositionFilterSwitchLabel',
    defaultMessage: 'Display Position Filter',
  },
  displayCategoryFilterSwitchLabel: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayCategoryFilterSwitchLabel',
    defaultMessage: 'Display Category Filter',
  },
  displayPositionFilterSwitchDesc: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayPositionFilterSwitchDesc',
    defaultMessage:
      'Allow potential applicants to filter openings by position and display position on job cards',
  },
  displayCategoryFilterSwitchDesc: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayCategegoryFilterSwitchDesc',
    defaultMessage:
      'Allow potential applicants to filter openings by category and display category on job cards',
  },
  displayJobTypeFilterSwitchLabel: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayJobTypeFilterSwitchLabel',
    defaultMessage: 'Display Job Type Filter',
  },
  displayJobTypeFilterSwitchDesc: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayJobTypeFilterSwitchDesc',
    defaultMessage:
      'Allow potential applicants to filter openings by job type and display job type on job cards',
  },
  displayRadiusFilterSwitchLabel: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayRadiusFilterSwitchLabel',
    defaultMessage: 'Display Radius Filter',
  },
  displayRadiusFilterSwitchDesc: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayRadiusFilterSwitchDesc',
    defaultMessage:
      'Allow potential applicants to filter openings by distance from current location or position location',
  },
  displayLocationNameSwitchLabel: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayLocationNameSwitchLabel',
    defaultMessage: 'Display Location Name Filter',
  },
  displayLocationNameSwitchDesc: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayLocationNameSwitchDesc',
    defaultMessage:
      'Allow potential applicants to filter openings by location name on positions.',
  },
  displayLocationAddressSwitchLabel: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayLocationAddressSwitchLabel',
    defaultMessage: 'Display Location Address',
  },
  displayLocationAddressSwitchDesc: {
    id: 'app.containers.AIJobsDirectoryCareerSite.displayLocationAddressSwitchDesc',
    defaultMessage:
      'Allow applicants to see the full address on openings in job directory and application forms.',
  },
  jobsDirectoryTranslationsTitle: {
    id: 'app.containers.AIJobsDirectoryCareerSite.jobsDirectoryTranslationsTitle',
    defaultMessage: 'Allow applicants to view page in other languages',
  },
  jobsDirectoryTranslationsDescription: {
    id: 'app.containers.AIJobsDirectoryCareerSite.jobsDirectoryTranslationsDescription',
    defaultMessage:
      'Applicants will be able to view the Job Directory page in the selected languages',
  },
  defaultLanguageTitle: {
    id: 'app.containers.AIJobsDirectoryCareerSite.defaultLocaleTitle',
    defaultMessage: 'Default Language',
  },
  defaultLanguageDescription: {
    id: 'app.containers.AIJobsDirectoryCareerSite.defaultLocaleDescription',
    defaultMessage:
      'Select the default language for the Job Directory page. This language will be used when an applicant first visits the page.',
  },
  selectDefaultLanguage: {
    id: 'app.containers.AIJobsDirectoryCareerSite.selectDefaultLocale',
    defaultMessage: 'Select a default language',
  },
  defaultLocationFilterTitle: {
    id: 'app.containers.AIJobsDirectoryCareerSite.defaultLocationFilterTitle',
    defaultMessage: 'Default Location',
  },
  defaultLocationFilterDescription: {
    id: 'app.containers.AIJobsDirectoryCareerSite.defaultLocationFilterDescription',
    defaultMessage:
      'Select the default location filter for the Job Directory page. This location type will be used when an applicant first visits the page.',
  },
  selectDefaultLocationFilter: {
    id: 'app.containers.AIJobsDirectoryCareerSite.selectDefaultLocationFilter',
    defaultMessage: 'Select a default location filter',
  },
});
